import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['company', 'customerVisibleSelect', 'companyCustomerMap'];

  changeCustomerOptions() {
    const companyId = this.companyTarget.value;
    const companyCustomerMap = JSON.parse(
      this.companyCustomerMapTarget.textContent,
    );
    const customers = companyId
      ? companyCustomerMap[companyId]
      : Object.values(companyCustomerMap).flat();

    // 担当の選択状態をリセット（表示と内部値の両方）
    const customerSelectController = this.application.getControllerForElementAndIdentifier(
      this.customerVisibleSelectTarget.closest('[data-controller="select"]'),
      'select',
    );
    if (customerSelectController) {
      customerSelectController.resetSelection();
    }

    // data-select-target="option" の着脱を行うことで、インクリメンタルサーチの対象を変更
    // 文字入力前にも表示状態を反映するため、ここでもhiddenクラスを着脱する
    const { children } = this.customerVisibleSelectTarget;
    Array.from(children).forEach((child) => {
      const key = child.dataset.selectKeyParam;
      if (
        customers.map((c) => c.name).includes(key)
        || key === '選択してください'
      ) {
        child.dataset.selectTarget = 'option';
        child.classList.remove('hidden');
      } else {
        child.dataset.selectTarget = '';
        child.classList.add('hidden');
      }
    });
  }
}
